import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Recharge = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');
  const [payType, setPayType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(null);

  const presetAmounts = [10, 50, 100, 200, 500];

  const handleAmountSelect = (value) => {
    setAmount(value.toString());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) <= 0) {
      setError('请输入有效的充值金额');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('access_token');
      const response = await axios.post('/api/jifen/recharge', {
        amount: parseInt(parseFloat(amount)),
        pay_type: payType
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setOrder(response.data);

      // 模拟支付过程
      setTimeout(() => {
        handlePayment(response.data.recharge_id);
      }, 1000);

    } catch (err) {
      setError('创建充值订单失败');
      console.error('创建充值订单失败:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = async (rechargeId) => {
    try {
      const token = localStorage.getItem('access_token');
      await axios.post(`/api/jifen/recharge/${rechargeId}/pay`, {
        third_order_no: `THIRD${Date.now()}`
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('支付成功！');
      navigate('/jifen/account');

    } catch (err) {
      setError('支付失败，请重试');
      console.error('支付失败:', err);
    }
  };

  const getPayTypeText = (type) => {
    const typeMap = {
      1: '微信支付',
      2: '支付宝',
      3: '银行卡'
    };
    return typeMap[type] || '未知';
  };

  return (
    <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">充值积分</h2>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
          <p className="text-red-600">{error}</p>
        </div>
      )}

      {!order ? (
        <form onSubmit={handleSubmit}>
          {/* 预设金额选择 */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              选择充值金额
            </label>
            <div className="grid grid-cols-3 gap-3 mb-4">
              {presetAmounts.map((value) => (
                <button
                  key={value}
                  type="button"
                  onClick={() => handleAmountSelect(value)}
                  className={`py-3 px-4 border rounded-lg text-center transition duration-200 ${
                    amount === value.toString()
                      ? 'border-blue-500 bg-blue-50 text-blue-600'
                      : 'border-gray-300 hover:border-gray-400'
                  }`}
                >
                  ¥{value}
                </button>
              ))}
            </div>

            {/* 自定义金额 */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                或输入自定义金额
              </label>
              <div className="relative">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">¥</span>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="输入金额"
                  className="w-full pl-8 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  min="0.01"
                  step="0.01"
                />
              </div>
            </div>
          </div>

          {/* 支付方式选择 */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-3">
              选择支付方式
            </label>
            <div className="space-y-3">
              {[1, 2, 3].map((type) => (
                <label key={type} className="flex items-center">
                  <input
                    type="radio"
                    value={type}
                    checked={payType === type}
                    onChange={(e) => setPayType(parseInt(e.target.value))}
                    className="text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-3 text-gray-700">{getPayTypeText(type)}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 充值说明 */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h3 className="text-sm font-medium text-blue-800 mb-2">充值说明</h3>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• 1元 = 1积分</li>
              <li>• 积分可用于发布悬赏和兑换权益</li>
              <li>• 支持微信支付、支付宝、银行卡</li>
              <li>• 充值成功后积分实时到账</li>
            </ul>
          </div>

          {/* 提交按钮 */}
          <button
            type="submit"
            disabled={true}
            className={`w-full py-3 px-4 rounded-lg text-white font-medium transition duration-200 bg-gray-400 cursor-not-allowed`}
          >
            充值功能暂未开放
          </button>
        </form>
      ) : (
        /* 订单确认页面 */
        <div className="text-center">
          <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
            <div className="text-green-600 mb-4">
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
              </svg>
            </div>
            <h3 className="text-lg font-medium text-green-800 mb-2">订单创建成功</h3>
            <p className="text-green-600">正在处理支付...</p>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 text-left">
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">订单号:</span>
                <span className="font-mono">{order.recharge_no}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">充值金额:</span>
                <span>¥{order.amount.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">到账积分:</span>
                <span>{order.integral}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">支付方式:</span>
                <span>{getPayTypeText(payType)}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Recharge;